export var ExternalIdProductTypeMap = {
  CHGStudyPckFT: '3BT_Signup',
  CHGStudyPcknoFT: '3B_Signup',
  // or '3B_Swap' if upsell
  CHGMnthCS3DFT: 'chegg study trial',
  CHGMnthCSV2FT: 'chegg study trial',
  'SCP-9': 'chegg study trial',
  CHGMnthCS7DFT: 'chegg study trial',
  CHGMnthCS3D: 'chegg study trial',
  CHGMnthCSPNFTPHPLCP: '3B_Signup',
  CHGCSP6MnthNFTMXNLCP: '3B_Signup',
  CHGMnthCSPNFTHKDLCP: '3B_Signup',
  CHGCSP6MnthNFTTRYLCP: '3B_Signup',
  CHGCSP12MnthNFTUKLCP: '3B_Signup',
  CHGMnthCSPNFTINRLCP: '3B_Signup',
  CHGMnthCSPNFTZARLCP: '3B_Signup',
  CHGCSP12MnthNFTMXNLCP: '3B_Signup',
  CHGMnthCSPNFTCAD: '3B_Signup',
  CHGCSP12MnthNFTKRWLCP: '3B_Signup',
  CHGCSP6MnthNFTAUDLCP: '3B_Signup',
  CHGMnthCSPNFTMYRLCP: '3B_Signup',
  CHGMnthCSPNFTKRW: '3B_Signup',
  CHGCSP12MnthNFTAUDLCP: '3B_Signup',
  CHGCSP6MnthNFTZARLCP: '3B_Signup',
  CHGCSP12MnthNFTZARLCP: '3B_Signup',
  CHGMnthCSPNFTSGDLCP: '3B_Signup',
  CHGCSP6MnthNFTUKLCP: '3B_Signup',
  CHGCSP12MnthNFTTRYLCP: '3B_Signup',
  CHGMnthCSPNFTTRY: '3B_Signup',
  CHGCSP12MnthNFTINRLCP: '3B_Signup',
  CHGCSP6MnthNFTINRLCP: '3B_Signup',
  CHGMnthCSPNFTMXN: '3B_Signup',
  CHGMnthCSPNFTAEDLCP: '3B_Signup',
  CHGMnthCSPNFTIDRLCP: '3B_Signup',
  CHGCSP12MnthNFTCADLCP: '3B_Signup',
  CHGMnthCSPNFTSARLCP: '3B_Signup',
  CHGCSP6MnthNFTCADLCP: '3B_Signup',
  CHGMnthCSPNFTAUD: '3B_Signup',
  CHGMnthCSPNFTGBP: '3B_Signup',
  CHGCSP6MnthNFTKRWLCP: '3B_Signup',
  CHGMnthCSNFTTRY: 'chegg study subscription',
  CHGMnthCSNFTZARLCP: 'chegg study subscription',
  CHGMnthCSNFTAUD: 'chegg study subscription',
  CHGMnthCSNFTGBPV2: 'chegg study subscription',
  CHGMnthCSNFTCADV2: 'chegg study subscription',
  CHGMnthCSNFTINRLCP: 'chegg study subscription',
  CHGMnthCSV2NFT: 'chegg study subscription',
  CHGMnthCSNFTAEDLCP: 'chegg study subscription',
  CHGMnthCSNFTSARLCP: 'chegg study subscription',
  CHGMnthCSNFTHKDLCP: 'chegg study subscription',
  CHGMnthCSNFTIDRLCP: 'chegg study subscription',
  CHGMnthCSNFTMYRLCP: 'chegg study subscription',
  CHGMnthCSNFTKRW: 'chegg study subscription',
  CHGMnthCSNFTPHPLCP: 'chegg study subscription',
  CHGMnthCSNFTSGDLCP: 'chegg study subscription',
  CHGMnthCSNFTMXN: 'chegg study subscription'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/constants/Rio.js
// module id = 1368
// module chunks = 11